import axios from "axios";
import { useEffect, useState } from "react";
import { webUrlNode } from "../../../constants/appInfo";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import AddStudentsToBatchModal from "./AddStudentsToBatchModal";
import FolderFilterCard from "../CreateContent/FolderFilterCard";
export default function BatchStudentsList({
 
  domain
}) {
  const AppToken = useSelector((state)=>state?.app?.app?.AppToken);
  const [students, setStudents] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadNewStudents, setLoadNewStudents] = useState(false);
  const [closePopUp, setClosePopUp] = useState(false);
  
  // 🔎 Filters
  const [search, setSearch] = useState("");
  const [role, setRole] = useState("student");
  const [status, setAccountStatus] = useState("active");
  const [registeredFrom, setRegisteredFrom] = useState("");
  const [registeredTo, setRegisteredTo] = useState("");

  const [sortBy, setSortBy] = useState("userRegisteredDate");
  const [sortOrder, setSortOrder] = useState("DESC");

  const [limit] = useState(10);
  const [offset, setOffset] = useState(0);

 const {batchId} = useParams();
 function buildUserFilters( AppToken) {
  return {
     role,
  search,
  accountStatus: status,
  registeredFrom,
  registeredTo,
  sortBy,
  sortOrder,
  limit,
  offset,
  appToken: AppToken
  };
}
  async function loadStudents() {

    try {

     

      const res = await axios.get(
  `${webUrlNode}/api/batches/${batchId}/students`,
  {
    params: buildUserFilters( AppToken)
  }
);

      setStudents(res.data.items || []);

    } catch (e) {

      console.error(e);

    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    loadStudents();
  }, [loadNewStudents, role,
  search,
  status,
  registeredFrom,
  registeredTo,
  sortBy,
  sortOrder,
  limit,
  offset,]);
 const nextPage = () => {
    setOffset(prev => prev + limit);
  };

  const prevPage = () => {
    setOffset(prev => Math.max(prev - limit, 0));
  };
  async function removeStudent(studentId) {

    if (!window.confirm("Remove student from batch?")) return;

    try {

      await axios.delete(
        `${webUrlNode}/api/batches/${batchId}/students/${studentId}?appToken=${AppToken}`,
        { params:{ } }
      );

      loadStudents();

    } catch (e) {
      console.error(e);
      alert("Failed to remove student");
    }
  }

  async function toggleStatus(id, status) {

    try {

      await axios.patch(
        `${webUrlNode}/api/batches/batch-students/${id}?appToken=${AppToken}`,
        {
         
          status: status === "active" ? "blocked" : "active"
        }
      );

      loadStudents();

    } catch (e) {

      console.error(e);

    }
  }

  if (loading) return <p>Loading students...</p>;

  return (
    <div style={{position:"relative",zIndex:9999}}>
      <FolderFilterCard  activeCard={true}   icon={6} title ="+ Students" onClickPopup={()=>{
  setClosePopUp(true)
} }  /> 
        
      {closePopUp?<AddStudentsToBatchModal
       existingStudents = {students}
  onClose={()=>{setClosePopUp(false)}}
  onCompleted={()=>{setLoadNewStudents(true);setTimeout(()=>{setLoadNewStudents(false)},100)}}
      />:""}
      <h3>Students ({students.length})</h3>
<div style={{ marginBottom: 20, display: "grid", gap: 10 }}>
<div  className="ikcraft_login-input-card" style={{marginTop:"-10px",padding:"0px"}}>

        <input   className="CreateCourseStepsOuterTextbox" 
          placeholder="Search name or email"
          value={search}
          onChange={(e) => {setSearch(e.target.value); setOffset(0)}}
        />
</div>
        <div style={{ display: "flex", gap: 10 }}>

          <select style={{fontSize:"20px",color:"#222222",background:"rgba(144, 202, 249,0.1)",border:"0px"
          ,borderRadius:"15px",cursor:"pointer",height:"35px"}} value={role} onChange={(e) => {setRole(e.target.value); setOffset(0)}}>
            <option value="">All Roles</option>
            <option value="student">Student</option>
            <option value="teacher">Teacher</option>
            <option value="staff">Staff</option>
            <option value="batchbuddy">BatchBuddy</option>
          </select>

          <select style={{fontSize:"20px",color:"#222222",background:"rgba(144, 202, 249,0.1)",border:"0px"
          ,borderRadius:"15px",cursor:"pointer",height:"35px"}}
            value={status}
            onChange={(e) => {setAccountStatus(e.target.value); setOffset(0)}}
          >
            <option value="">All Status</option>
            <option value="active">Active</option>
            <option value="blocked">Blocked</option>
          </select>

          <input style={{fontSize:"20px",color:"#222222",background:"rgba(144, 202, 249,0.1)",border:"0px"
          ,borderRadius:"15px",cursor:"pointer",height:"35px"}}
            type="date"
            value={registeredFrom}
            onChange={(e) => {setRegisteredFrom(e.target.value); setOffset(0)}}
          />

          <input style={{fontSize:"20px",color:"#222222",background:"rgba(144, 202, 249,0.1)",border:"0px"
          ,borderRadius:"15px",cursor:"pointer",height:"35px"}}
            type="date"
            value={registeredTo}
            onChange={(e) => {setRegisteredTo(e.target.value); setOffset(0)}}
          />

        </div>

        <div style={{ display: "flex", gap: 10 }}>

          <select  style={{fontSize:"20px",color:"#222222",background:"rgba(144, 202, 249,0.1)",border:"0px"
          ,borderRadius:"15px",cursor:"pointer",height:"35px"}}value={sortBy} onChange={(e) => {setSortBy(e.target.value); setOffset(0)}}>
            <option value="userRegisteredDate">Registered Date</option>
            <option value="firstName">First Name</option>
            <option value="lastName">Last Name</option>
            <option value="userEmail">Email</option>
            <option value="role">Role</option>
          </select>

          <select style={{fontSize:"20px",color:"#222222",background:"rgba(144, 202, 249,0.1)",border:"0px"
          ,borderRadius:"15px",cursor:"pointer",height:"35px"}} value={sortOrder} onChange={(e) => {setSortOrder(e.target.value); setOffset(0)}}>
            <option value="DESC">DESC</option>
            <option value="ASC">ASC</option>
          </select>

          

        </div>

      </div>

        {loading && <p>Loading...</p>}
      {students.length === 0 && (
        <p>No students enrolled</p>
      )}

      {students.map(s => (

        <div
          key={s.studentId}
          style={rowStyle}
        >

          <div style={{ display:"flex", gap:10 }}>

            <div>
              <strong>
                {s.firstName} {s.lastName}
              </strong>

              <div style={{ fontSize:12 }}>
                {s.userEmail}
              </div>

              <div style={{ fontSize:11 }}>
                Joined: {new Date(s.joinedAt).toLocaleDateString()}
              </div>

            </div>

          </div>

          <div style={{ display:"flex", gap:8 }}>

            <button style={{fontSize:"12px",color:"#ffffff",background:"rgba(0, 0, 0, 0.51)",border:"0px"
          ,borderRadius:"5px",cursor:"pointer",height:"35px", margin:"5px"}}
              onClick={() => toggleStatus(s.id, s.status)}
            >
              {s.status === "active"
                ? "Block"
                : "Unblock"}
            </button>

            <button style={{fontSize:"12px",color:"#222222",background:"rgba(249, 144, 144, 0.51)",border:"0px"
          ,borderRadius:"5px",cursor:"pointer",height:"35px", margin:"5px"}}
              onClick={() => removeStudent(s.studentId)}
             
            >
              Remove
            </button>

          </div>

        </div>

      ))}
{/* 📄 Pagination */}
      <div style={{  }}>
        <button style={{fontSize:"12px",color:"#222222",background:"rgba(144, 202, 249,0.51)",border:"0px"
          ,borderRadius:"5px",cursor:"pointer",height:"35px", margin:"5px"}} onClick={prevPage} disabled={offset === 0}>
          Previous
        </button>

        <button style={{fontSize:"12px",color:"#222222",background:"rgba(144, 202, 249,0.51)",border:"0px"
          ,borderRadius:"5px",cursor:"pointer",height:"35px", margin:"5px"}} onClick={nextPage}>
          Next
        </button>
      </div>
    </div>
  );
}

const rowStyle = {
  display:"flex",
  justifyContent:"space-between",
  alignItems:"center",
  padding:"10px",
  borderBottom:"1px solid #eee"
};